require("bootstrap");
window.$ = window.jQuery = jQuery;
import ResponsiveBootstrapToolkit from "responsive-toolkit";
import SVGInjector from "svg-injector";
import Swiper from "swiper";
import Cookies from "js-cookie";
import mixitup from "mixitup";
import { loadCSS } from "fg-loadcss";
import CrowdfundingProgress from "./components/CrowdfundingProgress";
import CrowdfundingIncentive from "./components/CrowdfundingIncentive";
import ScrollOffset from "./components/ScrollOffset";
import { createApp } from 'vue'
import CrowdfundingModule from './vue/CrowdfundingModule.vue';

const bodyScrollLock = require("body-scroll-lock");

/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

// Responsive bootstrap toolkit
var viewport = ResponsiveBootstrapToolkit;

//TODO checken of iban plugin en scrolllock werken!

// window.Parsley.on("field:error", function () {
// 	// This global callback will be called for any field that fails validation.
// 	console.log("Validation failed for: ", this.$element);
// });

window.initMap = function () {
	var mapOpts = {
		zoom: 12,
		zoomControl: false,
		rotateControl: false,
		mapTypeControl: false,
		streetViewControl: false,
		scaleControl: false,
		disableDefaultUI: true,
		draggable: false,
		draggableCursor: "default",
		scrollwheel: false,
		panControl: false,
		styles: [
			{
				featureType: "all",
				elementType: "labels.text",
				stylers: [
					{
						visibility: "off",
					},
				],
			},
			{
				featureType: "all",
				elementType: "labels.icon",
				stylers: [
					{
						visibility: "off",
					},
				],
			},
			{
				featureType: "administrative.country",
				elementType: "geometry.stroke",
				stylers: [
					{
						gamma: "1.00",
					},
					{
						weight: "0.50",
					},
				],
			},
		],
	};

	var markerImage = WPURLS["templateurl"] + "/dist/images/marker.png";

	if (jQuery(".single-project").length && typeof projectLat !== "undefined" && typeof projectLng !== "undefined") {
		var pos = new google.maps.LatLng(projectLat, projectLng);
		var map = new google.maps.Map(
			document.getElementById("map"),
			jQuery.extend({}, mapOpts, { zoom: 7, center: pos })
		);
		var marker = new google.maps.Marker({
			position: pos,
			map: map,
			icon: markerImage,
			clickable: false,
			cursor: "default",
		});

		if (viewport.is("md")) {
			map.panBy(-300, 0);
		}

		if (viewport.is("lg")) {
			map.panBy(-400, 0);
		}
	}

	if (
		jQuery(".contact-pagina-map").length &&
		typeof contactLat !== "undefined" &&
		typeof contactLng !== "undefined"
	) {
		var pos = new google.maps.LatLng(contactLat, contactLng);
		var map = new google.maps.Map(
			document.getElementById("map"),
			jQuery.extend({}, mapOpts, { zoom: 14, center: pos })
		);
		var marker = new google.maps.Marker({
			position: pos,
			map: map,
			icon: markerImage,
		});
	}
};

function debounce(func, wait, immediate) {
	var timeout;
	return function () {
		var context = this,
			args = arguments;
		var later = function () {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
}

(function ($) {
	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Edukans = {
		// All pages
		common: {
			init: function () {
				const progressBars = document.querySelectorAll('[data-progress-percentage]');
				progressBars.forEach((progressBar) => {
					new CrowdfundingProgress(progressBar);
				});

				const crowdfundingModule = document.querySelectorAll('[data-crowdfunding]');
				console.log(crowdfundingModule);
				crowdfundingModule.forEach((module) => {
					const app = createApp(CrowdfundingModule, JSON.parse(module.querySelector('script').textContent))
					app.mount(module);
				});

				const dataScrollEls = document.querySelectorAll('[data-scroll]');
				dataScrollEls.forEach((el) => {
					new ScrollOffset(el);
				});

				var $body = $("body");

				// SVGs
				var edukansSVGS = document.querySelectorAll("img.svg");
				SVGInjector(edukansSVGS);

				// Load counter from MyFonts
				if (WPURLS && WPURLS.wp_env !== "development") {
					loadCSS("//hello.myfonts.net/count/3129d7");
					loadCSS("//hello.myfonts.net/count/312c59");
				}

				function loadVideoSrc($el, src) {
					$el.attr("src", src);
					$el.attr("preload", "auto");
					$el[0].load();
				}

				$("[data-desktop-src], [data-mobile-src]").each(function () {
					var $el = $(this);

					if ($(window).width() > 767) {
						loadVideoSrc($el, $el.attr("data-desktop-src"));
					} else {
						loadVideoSrc($el, $el.attr("data-mobile-src"));
					}
				});

				// Menus
				function toggleMobileMenu() {
					if ($body.hasClass("mobile-menu-active")) {
						var enableBodyScroll = bodyScrollLock.enableBodyScroll;
						var targetElement = document.querySelector("body");
						enableBodyScroll(targetElement);
					} else {
						var disableBodyScroll = bodyScrollLock.disableBodyScroll;
						var targetElement = document.querySelector("body");
						disableBodyScroll(targetElement);
					}
					$body.toggleClass("mobile-menu-active");
				}

				function deactivateMobileMenu() {
					$body.removeClass("mobile-menu-active");
				}

				$(".m-projects-carousel").each(function () {
					var $el = $(this);

					var swiper = new Swiper($el.find(".swiper-container"), {
						spaceBetween: 25,
						slidesPerView: 1,
						grabCursor: true,
						nextButton: $el.find(".m-projects-carousel__next"),
						prevButton: $el.find(".m-projects-carousel__prev"),
					});
				});

				$(".m-image-text").each(function () {
					var $el = $(this);
					var video = $el.find("video");
					var playButton = $el.find(".button--play");

					if (video) {
						playButton.on("click", function () {
							$el.addClass("video-playing");
							video[0].play();
						});
					}
				});

				// slide in submenu mobile
				$(".mobile-menu__menu")
					.find(".menu-item-has-children")
					.find("a:first")
					.on("click", function (e) {
						e.preventDefault();

						$(this).closest(".menu-item-has-children").find(".sub-menu").addClass("sub-menu--active");
					});

				$(".mobile-menu__menu")
					.find(".btn-prev")
					.on("click", function (e) {
						e.preventDefault();
						$(this).closest(".sub-menu").removeClass("sub-menu--active");
						e.stopPropagation();
					});

				// Laat submenu zien bij menu item met children
				$(".site-header-primary__menu .menu-item-has-children")
					.on("mouseenter", function (e) {
						$(this).addClass("active");
						$body.addClass("drop-down-active");
					})
					.on("mouseleave", function (e) {
						$(this).removeClass("active");
						$body.removeClass("drop-down-active");
					});

				$(".btn-menu").on("click", function (e) {
					e.preventDefault();
					toggleMobileMenu();
				});

				// Sluit mobiele menu
				$(document).on("click", ".dimmer", function (e) {
					e.preventDefault();
					toggleMobileMenu();
				});

				// Meer info knop
				$(".entry .more-info").each(function () {
					var $el = $(this),
						$span = $el.find("span"),
						$parent = $el.parents("p"),
						$until = $parent.nextAll().hide();

					$el.on("click", function (e) {
						$until.toggle();

						var spanText = $span.text();

						if (spanText == "lees meer") {
							$span.text("inklappen");
						} else {
							$span.text("lees meer");
						}

						e.preventDefault();
					});
				});

				// MixItUp van programmas
				var mixer = false;

				function getHashFilter() {
					var hash = location.hash;
					var matches = location.hash.match(/filter=([^&]+)/i);
					var hashFilter = matches && matches[1];

					return hashFilter && decodeURIComponent(hashFilter);
				}

				function onHashChange() {
					var filterParam = getHashFilter();
					var filterString = filterParam ? filterParam : "all";
					var $programs = $(".m-highlight-pages__items.filter");
					var $imageText = $(".m-image-text ");

					if (filterString == "all") {
						$imageText.css({
							display: "flex",
						});
					} else {
						$imageText.css({
							display: "none",
						});
					}

					if ($programs.length) {
						if (!mixer) {
							mixer = mixitup(".m-highlight-pages__items.filter", {
								load: {
									filter: filterString,
								},
								animation: {
									duration: 300,
									effects: "fade",
									enable: false,
								},
							});
						} else {
							mixer.filter(filterString);
						}

						$(".filter-button")
							.removeClass("active")
							.filter('[data-filter="' + filterString + '"]')
							.addClass("active");
					}
				}

				$(".filter-button").on("click", function (e) {
					var $button = $(this);
					var filterAttr = $button.attr("data-filter");

					location.hash = "filter=" + encodeURIComponent(filterAttr);

					e.preventDefault();
				});

				$(window).on("hashchange", onHashChange);

				onHashChange();

				// Selectize
				jQuery(".fancy-select, .gfield_select").selectize({
					create: false,
				});

				// Gallery
				$(".entry .gallery").each(function () {
					$(this).magnificPopup({
						type: "image",
						delegate: "a",
						gallery: {
							enabled: true,
							tCounter: '<span class="mfp-counter">%curr% van %total%</span>',
						},
					});
				});

				// Donatie blok
				var selecteerTermijn = function (id) {
					const $id = $(id);
					if($id.length){
						//disable all
						$(".db-question__radio-container--amount-period")
							.css({ display: "none" })
							.find("input").attr("disabled", true);

						//enable the selected radio container
						$id
							.css({ display: "flex" })
							.find("input").attr("disabled", false);
					}


					var example = $id
						.find("input[type=radio]:checked")
						.closest("[data-example]")
						.attr("data-example");
					setExample(example);

					if (id == "#radio-eenmalig" || id == "#businessradio-eenmalig") {
						$("#betaalmethode").show();
						// $("#ideal").prop("checked", true);
						if ($('[data-crowdfunding-form]').length > 0) {
							$('[data-crowdfunding-form] [data-pay-methods]').show();
						}

						checkBetaalmethode();
					}
					if (id == "#radio-maandelijks" || id == "#radio-jaarlijks" || id == "#businessradio-maandelijks" || id == "#businessradio-jaarlijks") {
						$("#betaalmethode").hide();
						$("#machtiging").prop("checked", true);

						if ($('[data-crowdfunding-form]').length > 0) {
							$('[data-crowdfunding-form] [data-pay-methods]').hide();
							$('[data-crowdfunding-form] [data-pay-methods]').find('input[value="machtiging"]').prop('checked', true);
						}
						checkBetaalmethode();
					}
				};

				var checkBetaalmethode = function () {
					$("[data-payment-method]").addClass("doneren-section--visible");
					const updateFormFields = (form, method) => {
						const $form = $(form);
						const isIdeal = method === "ideal";
						const isMachtiging = method === "machtiging";

						$form.find("#bank").toggle(isIdeal);
						$form.find("#bank select").prop("required", isIdeal);
						$form.find("#bank input").prop("disabled", !isIdeal);
						$form.find("#bankselect-selectized").prop("required", isIdeal);
						$form.find("[data-address-container]").toggle(isMachtiging);
						$form.find("#rekeningnummer").toggle(isMachtiging);
						$form.find("#rekeningnummer input").prop("required", isMachtiging);
						$form.find("#rekeningnummer input").prop("disabled", !isMachtiging);

						if (method) {
							$form.find("[data-personal-data]").show();
						}
					};

					const selectedMethod = $("#betaalmethode input[type=radio]:checked").val();
					updateFormFields(document, selectedMethod);

					const $formSwitcher = $('[data-form-switcher]');
					if ($formSwitcher.length > 0) {
						const selectedForm = $formSwitcher.find('input:checked').val();
						const $selectedForm = $('[data-form="' + selectedForm + '"]');
						const formSelectedMethod = $selectedForm.find('#betaalmethode input[type=radio]:checked').val();
						updateFormFields($selectedForm, formSelectedMethod);
					}
				};

				$(document).on("click", "[data-period-choice]", function () {
					const period = $(this).data("period-choice");
					selecteerTermijn(period);

					const $elm = $(this);
					const example = $elm.attr("data-example");
					setExample(example);

					$(document).find(".radio-container__choice--zelf").find("input[type=number]").prop("required", false);
					$(document)
						.find(".radio-container__choice--zelf")
						.each(function(){
							const $this = $(this);
							$this.removeClass("doneren-form__validation-parent--error");
							if($this.parent().find('input[type=radio]').length > 1){
								$this.removeClass('visible');
							}
						});
				});

				$(document).on("click", "[data-example]", function () {
					$(document).find("[data-donation-container]").removeClass("hide-example");
					const $elm = $(this);
					const example = $elm.attr("data-example");
					setExample(example);

					$(document)
						.find(".radio-container__choice--zelf")
						.removeClass("visible doneren-form__validation-parent--error");
				});

				$(document).on("click", "[data-amount-choice]", function () {
					$(document).find(".radio-container__choice--zelf").find("input[type=number]").prop("required", false);
					$(document)
						.find(".radio-container__choice--zelf")
						.removeClass("visible doneren-form__validation-parent--error");
				});

				$(document).on("click", "input[name=betaalmethode]", function (evt) {
					checkBetaalmethode();
				});

				const setExample = function (example) {
					$(".choice__example").html(example);
				};

				$(document).on("click", ".radio-container__choice--zelf button", function (e) {
					e.preventDefault();
					const $wrapper = $(this).parents(".radio-container__choice--zelf");
					$wrapper.addClass("visible");
					$wrapper.find("input[type=radio]").prop("checked", true);
					$wrapper.find("input[type=number]").trigger("focus").prop("required", true);

					const $container = $(this).parents("[data-donation-container]");
					$container.addClass("hide-example");
				});

				// Restricts input for each element in the set of matched elements to the given inputFilter.
				$.fn.inputFilter = function (inputFilter) {
					return this.on("input keydown keyup mousedown mouseup select contextmenu drop", function () {
						if (inputFilter(this.value)) {
							this.oldValue = this.value;
							this.oldSelectionStart = this.selectionStart;
							this.oldSelectionEnd = this.selectionEnd;
						} else if (this.hasOwnProperty("oldValue")) {
							this.value = this.oldValue;
							this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
						}
					});
				};
				$(".custom-amount").inputFilter(function (value) {
					return /^-?\d*[.,]?\d{0,2}$/.test(value);
				});

				// Put value of custom amount input in amount radio
				$(".radio-container__choice--zelf")
					.find("input[type=number]")
					.on("keyup", function (data) {
						const $target = data.delegateTarget;
						const value = $target.value;
						const fixed = parseFloat(value);
						$(this).closest(".radio-container__choice--zelf").find("input[type=radio]").val(fixed);
					});

				// Postcode Check Donatieformulieren
				$("#input-straat", "#input-plaats").on("change", function () {
					$(this).data("changed", $(this).val().length > 0);
				});

				var $postcodeInput = $("[data-input-postcode]");
				$postcodeInput.on(
					"change",
					debounce(
						function (e) {
							const $elm = $(this)[0].closest("[data-address-autocomplete]");
							console.log('input', $elm);
							const inputData = $(this).val();
							if (inputData.length == 6 || inputData.length == 7) {
								$.ajax({
									url: "/wp/wp-admin/admin-ajax.php",
									data: {
										action: "lookup_postcode",
										postcode: inputData,
									},
									success: function (data) {
										console.log(data);
										var $street = $($elm).find("#input-straat");
										console.log($street);
										$street.val(data.street);


										var $city = $($elm).find("#input-plaats");
										$city.val(data.city);

										updateAddress($elm);
										return data;
									},
								});
							} else {
								$("#input-straat").val("");
								updateAddress($elm);
							}
						},
						500,
						false
					)
				);

				var $address = $("[data-address-autocomplete]");
				$address.on(
					"change",
					debounce(
						function () {
							updateAddress($(this)[0]);
						},
						500,
						false
					)
				);

				function updateAddress($elm) {
					let $target = $($elm);
					var straat = $target.find("#input-straat").val();
					var huisnummer = $target.find("#input-huisnummer").val();
					var toevoeging = $target.find("#input-toevoeging").val();
					var postcode = $target.find("#input-postcode").val();
					var plaats = $target.find("#input-plaats").val();

					if (postcode && straat && huisnummer && plaats) {
						const $adressBlock = $('[data-address-view]');
						$adressBlock.find(".input-straat").text(straat);
						$adressBlock.find(".input-huisnummer").text(huisnummer);
						if (toevoeging.length > 0) {
							$adressBlock.find(".input-toevoeging").text(" " + toevoeging);
						} else {
							$adressBlock.find(".input-toevoeging").text("");
						}
						$adressBlock.find(".input-postcode").text(postcode);
						$adressBlock.find(".input-plaats").text(plaats);
						$adressBlock.addClass("doneren-form__address--visible");
					} else {
						$(document).find("[data-address-view]").removeClass("doneren-form__address--visible");
					}
				}

				$(document).on("click", "#address-incorrect", function (evt) {
					evt.preventDefault();

					$(document)
						.find("[data-address-reveal]")
						.addClass("doneren-form__group--revealed")
						.find("input")
						.prop("required", true);

					$(this).closest("[data-address-view]").hide();
				});

				// Doneren Form Validation
				Parsley.addMessages("nl", {
					defaultMessage: "Deze waarde lijkt onjuist.",
					type: {
						email: "Dit lijkt geen geldig e-mail adres te zijn.",
						url: "Dit lijkt geen geldige URL te zijn.",
						number: "Deze waarde moet een nummer zijn.",
						integer: "Deze waarde moet een nummer zijn.",
						digits: "Deze waarde moet numeriek zijn.",
						alphanum: "Deze waarde moet alfanumeriek zijn.",
					},
					notblank: "Deze waarde mag niet leeg zijn.",
					required: "Dit veld is verplicht.",
					// pattern: "Kies een minimale donatiewaarde van € 1 of hoger.",
					min: "Kies een bedrag van minimaal €2,50.",
					max: "Deze waarde mag niet groter zijn dan %s.",
					range: "Deze waarde moet tussen %s en %s liggen.",
					minlength: "Deze tekst is te kort. Deze moet uit minimaal %s karakters bestaan.",
					maxlength: "Deze waarde is te lang. Deze mag maximaal %s karakters lang zijn.",
					length: "Deze waarde moet tussen %s en %s karakters lang zijn.",
					equalto: "Deze waardes moeten identiek zijn.",
				});
				Parsley.setLocale("nl");

				window.Parsley.addValidator("iban", {
					requirementType: "string",
					validateString: function (value, requirement) {
						return IBAN.isValid(value);
					},
					messages: {
						nl: "Dit is geen geldige IBAN",
						en: "This is not a valid IBAN",
					},
				});

				var $donerenForm = $("#doneren-form");
				if ($donerenForm.length > 0) {
					$("#doneren-form").parsley({
						trigger: "keyup focusout",
						validationThreshold: 0,
						uiEnabled: true,
						trigger: "change",
						successClass: "doneren-form__validation-parent--valid",
						errorClass: "doneren-form__validation-parent--error",
						classHandler: function (el) {
							return el.$element.closest(".doneren-form__validation-parent");
						},
						errorsWrapper: '<div class="doneren-form__invalid-message"></div>',
						errorTemplate: "<span></span>",
					});

					$(".bankselect").selectize({
						create: false,
					});
					$("#bankselect-selectized").prop("readonly", "readonly");
				}

				function getParameterByName(name) {
					name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
					var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
						results = regex.exec(location.search);

					return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
				}

				var $nameEmailform = $("#name_email_form");
				if ($nameEmailform.length > 0) {
					$("#name_email_form").parsley({
						trigger: "keyup focusout",
						validationThreshold: 0,
						uiEnabled: true,
						trigger: "change",
						successClass: "doneren-form__validation-parent--valid",
						errorClass: "doneren-form__validation-parent--error",
						classHandler: function (el) {
							return el.$element.closest(".doneren-form__validation-parent");
						},
						errorsWrapper: '<div class="doneren-form__invalid-message"></div>',
						errorTemplate: "<span></span>",
					});
				}

				$(function () {
					// Set termijn
					var termijn = getParameterByName("termijn");
					if (termijn) {
						$("#" + termijn).prop("checked", true);
					}

					// Set amounts
					var amount = getParameterByName(termijn);
					var $amountRadio = $("#radio-" + termijn).find('input[value="' + amount + '"]');
					if ($amountRadio.length > 0) {
						$("#radio-" + termijn)
							.find('input[value="' + amount + '"]')
							.prop("checked", true);
						var example = $("#radio-" + termijn)
							.find('input[value="' + amount + '"]')
							.closest("li")
							.attr("data-example");
						setExample(example);
					} else {
						const $wrapper = $("#radio-" + termijn).find(".radio-container__choice--zelf");

						$("#radio-" + termijn)
							.find(".radio-container__choice--zelf")
							.find("input[type=radio]")
							.prop("checked", true)
							.val(amount);
						$("#radio-" + termijn)
							.find(".custom-amount")
							.val(amount);
						$wrapper.addClass("visible");
					}

					if (termijn) {
						selecteerTermijn("#radio-" + termijn);
					} else {
						var selectedTermijn = $("#radio-termijn").find("input[type=radio]:checked").val();
						selecteerTermijn("#radio-" + selectedTermijn);
						if (selectedTermijn == "eenmalig") {
							$("#ideal").prop("checked", false);
							$("[data-payment-method]").removeClass("doneren-section--visible");
						}
					}

					if ($('[data-form-switcher]').length > 0) {
						if (new URLSearchParams(window.location.search).get('target') == 'zakelijk') {
							selecteerTermijn('#businessradio-eenmalig');
						}
					}

					// Honeypot
					$("#doneren-form").on("submit", function () {
						$("[data-button-submit]").addClass("is-loading");
						if ($("input#haircolor").val().length != 0) {
							return false;
						}
					});

					$("#name-email-form").submit(function () {
						if ($("input#haircolor").val().length != 0) {
							return false;
						}
					});
				});

				// File upload aanpassingen
				const $fileUploads = $(".ginput_container_fileupload");

				$fileUploads.each(function (e) {
					const $input = $(this).find('input[type="file"]');
					const $currentFileUpload = $(this);
					$input.hide();

					const labelclasses = "buttonn button--blue button--uppercase button--full-width";
					$input.after(`<label for="${$input.attr("id")}" class="${labelclasses}">Upload je bestand</label>`);

					$input.on("change", function () {
						const file = this.files[0];
						$currentFileUpload.find(".uploaded-field").remove();
						$input.after(
							`<div class="uploaded-field">
								<span class="uploaded-field__name">${file.name}</span>
								<span class="uploaded-field__filesize">${formatBytes(file.size)}</span>
								<svg data-removedownload width="15" height="15" xmlns="http://www.w3.org/2000/svg"><path d="M12.803 2.196A7.5 7.5 0 102.197 12.804 7.5 7.5 0 0012.803 2.196zm-2.625 7.2a.536.536 0 010 .783.536.536 0 01-.755 0L7.499 8.255 5.603 10.18a.536.536 0 01-.755 0 .536.536 0 010-.756L6.744 7.5 4.848 5.604a.536.536 0 01.755-.756l1.896 1.897 1.897-1.897a.544.544 0 01.782.756L8.255 7.5l1.923 1.896z" fill="#000" fill-rule="nonzero" opacity=".494"/></svg>
							</div>`
						);
					});
				});

				$(document).on("click", "[data-removedownload]", function () {
					const $fileUploadContainer = $(this).closest(".ginput_container_fileupload");
					$fileUploadContainer.find(".uploaded-field").remove();
					$fileUploadContainer.find('input[type="file"]').val("");
				});

				function formatBytes(bytes, decimals = 2) {
					if (bytes === 0) return "0 Bytes";

					const k = 1024;
					const dm = decimals < 0 ? 0 : decimals;
					const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

					const i = Math.floor(Math.log(bytes) / Math.log(k));

					return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
				}

				if ($('[data-form-switcher]').length > 0) {
					$('[data-form-switcher] input:radio').on('click', function (e) {
						checkCrowdfundingForm();
					});

					function checkCrowdfundingForm(skipPeriodChoice = false) {
						$('[data-form]').hide();
						const form = $('[data-form-switcher]').find('input:checked')[0].value;
						$(`[data-form="${form}"]`).show();

						if (!skipPeriodChoice) {
							const periodChoice = $(`[data-form="${form}"]`).find('[data-period-choice]');
							if (periodChoice.length > 0) {
								periodChoice[0].click();
							}
						}
					}

					checkCrowdfundingForm(true);
				}

				$('[data-read-more]').on('click', function (e) {
					$(this).parent().toggleClass('donation__introduction--expanded');
				});


				document.querySelectorAll('[data-incentive]').forEach((incentive) => {
					new CrowdfundingIncentive(incentive);
				});
			},
		},
		home: {
			init: function () {
				var modalCookie = Cookies.get("modal"),
					$featuredPopup = $(".featured-popup");

				if ($featuredPopup.length) {
					var modalId = $featuredPopup.attr("data-id");

					if (modalCookie !== modalId) {
						$featuredPopup.modal();
					}

					$featuredPopup.on("hide.bs.modal", function (e) {
						Cookies.set("modal", modalId, { expires: 7 });
					});

					$featuredPopup.on("click", "a", function (e) {
						Cookies.set("modal", modalId, { expires: 7 });
					});
				}
			},
		},
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function (func, funcname, args) {
			var fire;
			var namespace = Edukans;
			funcname = funcname === undefined ? "init" : funcname;
			fire = func !== "";
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === "function";

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function () {
			// Fire common init JS
			UTIL.fire("common");

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, "_").split(/\s+/), function (i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, "finalize");
			});

			// Fire common finalize JS
			UTIL.fire("common", "finalize");
		},
	};

	// Load Events
	$(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
